
const blockInvoicesModule = {
    namespaced: true,
    state: {
        updating: {
            actualDate: null,
            status: 2,
            isUpdating: false,  
        },
        captcha: {
            img: null,
            token: null,
            isCaptcha: false
        },
        updatingType: process.env.BLOCK_INV_UPD_TYPE,
        invoicesList: [],
        historyList: [],
        requestCount: 0,
        maxIterCount: 6,
        timeInterval: 10, //sec
        errorMessage: ''
    },
    actions: {
        throwInvoicesError({ commit }) {
            commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
            commit('setStateObject', { name: 'card.invoices.errorMessage', value: 'Данные по компании не найдены' }, { root: true })
        },
        //Получение списка актуальных и архивных блокировок РС
        getInfo({ commit, dispatch, state }, { inn, ogrn }) {
            commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: true }, { root: true })

            return dispatch('v3/API', {
                method: 'block_invoices',
                data: {
                    action: 'get_info',
                    inn,
                    ogrn
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0 ) {
                    // Если status 1 или 2 выводим списки решений о блокировке РС в плитку
                    if([1,2].includes(Number(e.data?.data?.status))) {
                        commit(
                            'setStateObject', 
                            { name: 'card.invoices.invoicesList', value: e.data?.data?.list_block_invoices ?? [] }, 
                            { root: true }
                        )
                        commit(
                            'setStateObject',
                            {
                                name: 'card.invoices.updating',
                                value: {
                                    actualDate: e.data?.data?.actual_date || '',
                                    status: e.data?.data?.status || 2,
                                    isUpdating: false
                                }
                            },
                            { root: true }
                        )
                        // Если status === 0 то делаем еще запрос на получение спика, пока не получим status > 0 
                        // или пока не сделаем 6 неудачных запросов
                    } else if(Number(e.data?.data?.status) === 0 && state.requestCount < state.maxIterCount) {
                        return new Promise(resolve => {
                            setTimeout(() => {
                                resolve({ inn, ogrn })
                            }, state.timeInterval * 1000)
                        }).then(data => {
                            commit('setStateObject', { name: 'card.invoices.requestCount',  value: state.requestCount++ }, { root: true })
                            return dispatch('getInfo', data)
                        })
                    }
                } else {
                    dispatch('throwInvoicesError')
                }
            }).catch(err => {
                dispatch('throwInvoicesError')
                console.error(err.message)
            })
        },
        // Запрос на получение истории запросов 
        getHistoryInfo({ dispatch, commit }, { inn, ogrn }) {

            return dispatch('v3/API', {
                method: 'block_invoices',
                data: {
                    action: 'get_history',
                    inn,
                    ogrn
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit('setStateObject', { name: 'card.invoices.historyList', value: e.data?.data?.list_history_bi ?? [] }, { root: true })
                }
            }).catch(err => {
                console.error(err.message)
            })
        },
        // Обновление
        // В зависимости от переменной из .env экшен решает как обновялть с капчй или без
        updateInvoices({ state, commit, dispatch }, companyCodesObj) { // companyCodesObj = { inn, ogrn, token?, captcha? }
            commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: true }, { root: true })
            const { updatingType } = state

            if(updatingType === 'auto') {
                return dispatch('update', companyCodesObj)
            } else if(updatingType === 'captcha') {
                return dispatch('getCaptcha', companyCodesObj)
            } else {
                console.error('Неизвестный тип обновления')
                commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
            }
        },
        // Обновление
        update({ commit, dispatch, state }, { inn, ogrn, captcha, token }) {
            commit('setStateObject', { name: 'card.invoices.captcha.isCaptcha', value: false }, { root: true })
            commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: true }, { root: true })

            return dispatch('v3/API', {
                method: 'block_invoices',
                data: {
                    action: state.updatingType === 'auto' ? 'auto_upd_info' : 'upd_info',
                    inn,
                    ogrn,
                    captcha,
                    token
                }
            }, { root: true }).then(e => {

                if(e.status === 200) {
                    if(e.data?.data?.code_err === 2) {
                        commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
                        dispatch('showErrorPopUp', 'Введен неправильный код с картинки.', { root: true })
                        return
                    }
                    if(Number(e.data?.code) === 0) {
                        commit('setStateObject', { name: 'card.invoices.requestCount', value: 0 }, { root: true })
                        dispatch('getInfo', { inn, ogrn })
                    } else {
                        commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
                    }
                }
            }).catch(err => {
                commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
                dispatch(
                    'showErrorPopUp', 
                    'При загрузке данных произошла ошибка. Повторите ваш запрос позднее или обратитесь в службу технической поддержки.',
                    { root: true }
                )
                console.error(err.message)
            })
        },
        // Получение капчи
        getCaptcha({ commit, dispatch }, { inn, ogrn }) {
            commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })

            return dispatch('v3/API', {
                method: 'block_invoices',
                data: {
                    action: 'get_captcha',
                    inn,
                    ogrn
                }
            }, { root: true } ).then(e => {
                if(e.status === 200 && e.data?.code === 0 && e.data?.data?.status === 0) {
                    const { captcha, token } = e.data?.data
                    commit(
                        'setStateObject',
                        {
                            name: 'card.invoices.captcha',
                            value: {
                                img: captcha,
                                isCaptcha: true,
                                token
                            }
                        },
                        { root: true }
                    )
                    commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
                } else {
                    commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
                    dispatch(
                        'showErrorPopUp', 
                        'При загрузке данных произошла ошибка. Повторите ваш запрос позднее или обратитесь в службу технической поддержки.',
                        { root: true }
                    )
                }
            }).catch(err => {
                commit('setStateObject', { name: 'card.invoices.updating.isUpdating', value: false }, { root: true })
                console.error(err.message)
            })
        },
    },
    getters: {
        actualList(state) {
            return state.invoicesList.length ? state.invoicesList.filter(e => Number(e.actuality) === 1) : [] 
        },
        archiveList(state) {
            return state.invoicesList.length ? state.invoicesList.filter(e => Number(e.actuality) === 0) : [] 
        }
    }
}

export default blockInvoicesModule